import { render, staticRenderFns } from "./modal-edit-activity-type.vue?vue&type=template&id=d5bbe664&"
import script from "./modal-edit-activity-type.vue?vue&type=script&lang=js&"
export * from "./modal-edit-activity-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports